<template>
    <div class="layout-footer">
        <div>
            <router-link to="/">
                <div
                    class="layout-topbar-logo"
                    id="logolink"
                    style="cursor: pointer; outline: none"
                >
                    <img v-if="authStore.selectedProduct !== null"
                        :class="['w-full h-3rem', { 'footer-logo': !authStore.isGodUser && !authStore.isFallbackProductLogo}]"
                        id="app-logo"
                        alt="product logo"
                        :src="authStore.companyLogoUrl"
                    />
                </div>
            </router-link>
        </div>
        <div>
            <a
                href="https://ignis.freshdesk.com/support/solutions/202000069360"
                target="_blank"
                class="help-guide-btn"
                v-tooltip.top="'Help Guide'"
            >
                <i class="pi pi-question-circle"></i>
                <span>Help Guide</span>
            </a>
        </div>
    </div>
</template>

<script setup>
import { useAuthStore } from '@/modules/auth/store';

const authStore = useAuthStore();
</script>

<style scoped>
.layout-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer-logo {
  width: 100px !important;
  height: 50px !important;
  object-fit: contain;
  display: block;
}
.help-guide-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1.25rem;
  border-radius: 2rem;
  background: var(--primary-color);
  color: #ffffff;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  transition: all 0.2s ease;
}
.help-guide-btn:hover {
  background: var(--primary-dark-color, var(--primary-color));
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transform: translateY(-1px);
  color: #ffffff;
}
.help-guide-btn i {
  font-size: 1rem;
}
</style>
